import { render } from "./ModalLegend.vue?vue&type=template&id=4b5354a8"
import script from "./ModalLegend.vue?vue&type=script&lang=js"
export * from "./ModalLegend.vue?vue&type=script&lang=js"

import "./ModalLegend.vue?vue&type=style&index=0&id=4b5354a8&lang=css"
script.render = render

export default script